type ServerRouteMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE" | "OPTIONS"

type ServerRouteHandlerContext = {
  request: Request
}

type ServerRouteHandler = (context: ServerRouteHandlerContext) => Response | Promise<Response>

type ServerRouteConfig = {
  server: {
    handlers: Partial<Record<ServerRouteMethod, ServerRouteHandler>>
  }
}

export function serverRouteConfig<T extends ServerRouteConfig>(config: T): never {
  return config as never
}
